import React from 'react'

import UserActivityControlPanel from './UserActivityControlPanel'
import UserActivityDonePanelForTodayActivity from './UserActivityDonePanelForTodayActivity'
import UserActivityDonePanelForYesterdayActivity from './UserActivityDonePanelForYesterdayActivity'
import UserStoryFormForTodayActivity from './UserStoryFormForTodayActivity'
import UserStoryFormForYesterdayActivity from './UserStoryFormForYesterdayActivity'

const UserActivityBlock = ({
  isShowStoryForm,
  isShowDonePanel,
  isShowControlPanel,
  isShowStoryFormForYesterdayActivity,
  isShowDonePanelForYesterdayActivity,
}) => (
  <div className="user-activity-block">
    {isShowStoryForm ? (
      <UserStoryFormForTodayActivity />
    ) : (
      isShowStoryFormForYesterdayActivity && <UserStoryFormForYesterdayActivity />
    )}
    {isShowDonePanel ? (
      <UserActivityDonePanelForTodayActivity />
    ) : (
      isShowDonePanelForYesterdayActivity && <UserActivityDonePanelForYesterdayActivity />
    )}
    {isShowControlPanel ? <UserActivityControlPanel /> : null}
  </div>
)

export default UserActivityBlock
